import React, { useContext } from "react";
import { Box, Divider, Drawer, IconButton, List, Stack, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import MenuContent from "./MenuContent";
import PimsBranding from "./PimsBranding";
import { ReactComponent as Logo } from "../assets/KaproSCMIcon.svg";
import { LanguageContext } from "./LanguageContext";

const DRAWER_WIDTH = 280;

const SideMenuMobile = ({ open, onClose }) => {
    const { translations } = useContext(LanguageContext);

    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: DRAWER_WIDTH,
                    bgcolor: "background.paper",
                    backgroundImage: "none",
                    borderRight: (theme) => `1px solid ${theme.palette.divider}`,
                    display: "flex",
                    flexDirection: "column",
                },
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ px: 2, py: 1.5, minHeight: 64 }}
            >
                <Stack direction="row" alignItems="center" spacing={1.5}>
                    <Box sx={{ width: 36, height: 36 }}>
                        <Logo style={{ width: "100%", height: "100%" }} />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: "0.2px" }}>
                        {translations.appName || "KaproSCM"}
                    </Typography>
                </Stack>
                <IconButton onClick={onClose} edge="end">
                    <CloseRoundedIcon />
                </IconButton>
            </Stack>

            <Divider />

            <Box sx={{ px: 1, py: 2, flex: 1, overflowY: "auto" }}>
                <List component="nav" sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                    <MenuContent collapsed={false} onItemClick={onClose} />
                </List>
            </Box>

            <Divider />
            <PimsBranding />
        </Drawer>
    );
};

export default SideMenuMobile;